import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "timeDifference",
  pure: false,
  standalone: true,
})
export class TimeDifferencePipe implements PipeTransform {
  transform(value: string): string {
    return this.setDifferenceTime(new Date(value));
  }

  private setDifferenceTime(createdDate: Date): string {
    const now = new Date();
    const timeDifference = now.getTime() - createdDate.getTime();

    // Convert milliseconds to seconds
    const secondsDifference = Math.floor(timeDifference / 1000);

    if (secondsDifference < 60) {
      return `just now`;
    } else if (secondsDifference < 3600) {
      const minutes = Math.floor(secondsDifference / 60);
      return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
    } else if (secondsDifference < 86400) {
      const hours = Math.floor(secondsDifference / 3600);
      return `${hours}h${hours > 1 ? "s" : ""} ago`;
    } else if (this.isExactlyFiveDaysAgo(now, createdDate)) {
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour12: false,
        hour: "numeric",
        minute: "numeric",
      };
      return createdDate.toLocaleDateString("en-US", options);
    } else if (this.isLongerThanFiveDaysAgo(now, createdDate)) {
      const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour12: false,
        hour: "numeric",
        minute: "numeric",
      };
      return createdDate.toLocaleDateString("en-US", options);
    } else {
      const days = Math.floor(secondsDifference / 86400);
      return `${days}d ago`;
    }
  }

  private isExactlyFiveDaysAgo(now: Date, createdDate: Date): boolean {
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    return (
      Math.abs(now.getTime() - createdDate.getTime()) === 5 * millisecondsInADay
    );
  }

  private isLongerThanFiveDaysAgo(now: Date, createdDate: Date): boolean {
    const millisecondsInADay = 24 * 60 * 60 * 1000;
    return now.getTime() - createdDate.getTime() > 5 * millisecondsInADay;
  }
}
